var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redes-view"},[_c('NavarCamara'),_c('BannerCamara'),_c('CategoriaCamara'),_c('CamaraFqa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }